import React from 'react';
import { BookOpen } from 'lucide-react';
import type { CourseDetails } from '../../hooks/useCourseApi';
import { getCourseBookUrl, resolveFileUrl } from '../../utils/lessonHelpers';

interface CourseBookLinkProps {
  courseDetails: CourseDetails;
  className?: string;
}

const CourseBookLink: React.FC<CourseBookLinkProps> = ({ courseDetails, className = '' }) => {
  const bookUrl = getCourseBookUrl(courseDetails);
  if (!bookUrl) return null;

  return (
    <a
      href={resolveFileUrl(bookUrl)}
      target="_blank"
      rel="noopener noreferrer"
      className={`flex items-center gap-4 rounded-2xl border border-emerald-100 bg-white px-5 py-4 shadow-[0_4px_20px_rgba(0,0,0,0.05)] transition-colors hover:bg-emerald-50/80 hover:border-emerald-200 ${className}`}
    >
      <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-emerald-600 to-emerald-800 flex items-center justify-center shrink-0 shadow-md shadow-emerald-900/15">
        <BookOpen className="w-6 h-6 text-white" strokeWidth={2} aria-hidden />
      </div>
      <div className="min-w-0 flex-1 text-right">
        <p className="font-el-messiri text-lg font-bold text-slate-900">كتاب المادة</p>
        <p className="font-cairo text-sm text-slate-500">فتح أو تحميل الكتاب</p>
      </div>
    </a>
  );
};

export default CourseBookLink;
